import { render, staticRenderFns } from "./ArticlesCreate.vue?vue&type=template&id=059126b9&"
import script from "./ArticlesCreate.vue?vue&type=script&lang=js&"
export * from "./ArticlesCreate.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesCreate.vue?vue&type=style&index=0&id=059126b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports